import React, { useEffect } from 'react';

const USERSNAP_WIDGET_URL = 'https://widget.usersnap.com/global/load/61576bf3-0ac6-430d-a1b0-fff1f4fd5c74?onload=onUsersnapLoad';

function UserSnap() {
  useEffect(() => {
    window.onUsersnapLoad = function(api) {
      api.init();
    };
    const script = document.createElement('script');
    script.defer = true;
    script.src = USERSNAP_WIDGET_URL;
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window.onUsersnapLoad;
    };
  }, []);

  return null; // Widget is injected, nothing to render
}

export default UserSnap;
